import { AppBox } from "../../../../../commons/components";
import { IFootballTeamCoach } from "../../../../../commons/models/football/interface/i-football-team-coach";
import { toTitleCase } from "../../../../../commons/utilities/string-utils";

interface TeamCoachRemoveProps {
  teamCoach: IFootballTeamCoach;
}
export default function TeamCoachRemove({ teamCoach }: TeamCoachRemoveProps) {
  return (
    <AppBox displayBlock>
      Do you want to remove <strong>“{toTitleCase(teamCoach?.fullName)}” </strong> from the team? Once you remove the
      coach, the action cannot be undone.
    </AppBox>
  );
}
